import React, { useState } from 'react';
import '../styles/APIKeyModal.css';
import { Button, Input } from '../components';
import { HugeiconsIcon } from '@hugeicons/react';
import { Copy01Icon } from '@hugeicons/core-free-icons';
import { colour } from '../styles/GlobalStyles';
import { TickHeavy } from "../assets/icons";

function APIKeyModal(props) {
    const apiKey = props.apiKey;
    const [copied, setCopied] = useState(false);

    const copyKey = async() => {
        setCopied(true);
        try {
            await navigator.clipboard.writeText(apiKey);
        } 
        catch (err) {
            console.log("Clipboard copy failed:", err);
            setCopied(false);
        }
    };

    return (
        <div className="api-key-modal-body-container">
            <span className="body-regular colour-primary">
                Please save this key. You will <span className="body-bold">not be able to view it again</span> for security reasons. 
                If you lose it, you will need to generate a new one.
            </span>
            <div className="api-key-modal-body-input-container">
                <Input
                    label={"API key"}
                    labelType={"default"}
                    secondaryLabelGrey={null}
                    info={false}
                    value={""}
                    onChange={null}
                    placeholder={apiKey}
                    type="text"
                    leftUnit={null}
                    rightUnit={null}
                    unitSwitch={false}
                    leftUnitSelected={true}
                    unitSwitchFunc={null}
                    disabled={true}
                    multiline={false}
                    error={false}
                    onMouseEnter={null}
                    onMouseLeave={null}
                    reset={false}
                    resetFunc={null}
                    resetPosition={null}
                    focusMultiline={false}
                    prompt={false}
                    submitPromptDisabled={false}
                    submitPrompt={null}
                    onHeightChange={null}
                />
                <div className="api-key-modal-body-copy-container">
                    <Button
                        buttonType="primary-button"
                        size="medium"
                        text={copied === true ? "Copied" : "Copy"}
                        cta={copyKey}
                        disabled={false}
                        leftIcon={copied === true ? <TickHeavy fill={colour.gray00} className="" />  : <HugeiconsIcon icon={Copy01Icon} color={colour.gray00} size={14} />}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
            </div>
        </div>
    )
};

export default APIKeyModal;